import type { Location } from "@/domains/navigation/navigation-item"
import type { BreadcrumbItem } from "@/domains/navigation/types/complex-breadcrumb-item"

/**
 * Creates a simple breadcrumb item for diagnostics pages
 */
export function createBreadcrumbItem(
  id: string,
  label: string,
  href: string,
  isActive: boolean = false,
): BreadcrumbItem {
  return {
    id,
    label,
    href,
    iconName: "",
    isExternal: false,
    isActive: (location: Location) => {
      if (isActive) {
        return location.pathname === href || location.pathname.startsWith(href + "/")
      }
      return false
    },
    generateHref: () => href,
    setActiveStrategy: () => {},
    setURLStrategy: () => {},
    setParent: () => {},
  }
}
